import { render } from "./VeneersView.vue?vue&type=template&id=29a40417&scoped=true"
import script from "./VeneersView.vue?vue&type=script&lang=js"
export * from "./VeneersView.vue?vue&type=script&lang=js"

import "./VeneersView.vue?vue&type=style&index=0&id=29a40417&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a40417"]])

export default __exports__